import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query";
import { RootState } from "store";
import { removeUser } from "store/slices/auth";
import { BASE_URL, HttpStatusCode } from "./constants";

const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders: (headers, { getState, endpoint }) => {
    const state = getState() as RootState;
    const accessToken = state.auth.token;
    if (accessToken) {
      headers.set("Authorization", `Bearer ${accessToken}`);
    }
    if (
      !headers.has("Content-Type") &&
      endpoint !== "uploadDriverPhoto" &&
      endpoint !== "uploadNotificationImage" &&
      endpoint !== "createDriver"
    ) {
      headers.set("Content-Type", "application/json");
    }
    return headers;
  },
});

export const baseQueryConfig: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === HttpStatusCode.UNAUTHORIZED) {
    api.dispatch(removeUser());
  }

  return result;
};
